// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3N3-h","label":"Completed_label__1CdRu"};